import React from "react"
import PropTypes from "prop-types"
import { formatCurrency, formatNumber, reglaConfig, colorPara } from "../helpers"

const ReglaBadge = ({ regla }) => {
  const cfg = reglaConfig(regla)
  return (
    <span
      style={{
        display: "inline-block", padding: "2px 8px", borderRadius: 4,
        background: cfg.bg, color: cfg.color,
        fontSize: 11, fontWeight: 700, textTransform: "uppercase",
      }}
      title={cfg.desc}
    >
      {cfg.label}
    </span>
  )
}

ReglaBadge.propTypes = { regla: PropTypes.string }

const PagosTab = ({ data }) => {
  const metodos = data?.metodos_pago || []
  const totales = data?.totales || {}

  if (metodos.length === 0) {
    return (
      <div style={{ padding: 60, textAlign: "center", color: "#64748b" }}>
        <i className="mdi mdi-credit-card-off-outline" style={{ fontSize: 48, color: "#cbd5e1" }} />
        <div className="mt-2">Sin métodos de pago registrados.</div>
      </div>
    )
  }

  const totalOriginal = metodos.reduce((s, m) => s + (Number(m.valor_original) || 0), 0)
  const totalAjustado = metodos.reduce((s, m) => s + (Number(m.valor_ajustado) || 0), 0)
  const huboAjustes = Math.abs(totalOriginal - totalAjustado) > 0.01

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      {/* Stats arriba */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
        <div style={{ flex: "1 1 180px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, padding: 14 }}>
          <div style={{ fontSize: 11, color: "#64748b", textTransform: "uppercase", fontWeight: 600 }}>Métodos</div>
          <div style={{ fontSize: 22, fontWeight: 700, color: "#0f172a", marginTop: 2 }}>{formatNumber(metodos.length)}</div>
        </div>
        <div style={{ flex: "1 1 220px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, padding: 14, borderLeft: "4px solid #94a3b8" }}>
          <div style={{ fontSize: 11, color: "#64748b", textTransform: "uppercase", fontWeight: 600 }}>Suma original (POS)</div>
          <div style={{ fontSize: 18, fontWeight: 700, color: "#94a3b8", marginTop: 2 }}>{formatCurrency(totalOriginal)}</div>
        </div>
        <div style={{ flex: "1 1 220px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, padding: 14, borderLeft: "4px solid #10b981" }}>
          <div style={{ fontSize: 11, color: "#64748b", textTransform: "uppercase", fontWeight: 600 }}>Suma ajustada</div>
          <div style={{ fontSize: 18, fontWeight: 700, color: "#0f172a", marginTop: 2 }}>{formatCurrency(totalAjustado)}</div>
        </div>
        <div style={{ flex: "1 1 220px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, padding: 14, borderLeft: `4px solid ${totalAjustado === Number(totales.factura_total) ? "#10b981" : "#dc2626"}` }}>
          <div style={{ fontSize: 11, color: "#64748b", textTransform: "uppercase", fontWeight: 600 }}>Total factura</div>
          <div style={{ fontSize: 18, fontWeight: 700, color: "#0f172a", marginTop: 2 }}>{formatCurrency(totales.factura_total)}</div>
        </div>
      </div>

      {huboAjustes && (
        <div style={{
          background: "#fffbeb", border: "1px solid #fde68a",
          color: "#92400e", padding: "10px 14px", borderRadius: 8,
          fontSize: 13,
        }}>
          <i className="mdi mdi-information-outline me-1" />
          El POS reportó <strong>{formatCurrency(totalOriginal)}</strong> pero el back ajustó algunos métodos
          para cuadrar con el total real <strong>{formatCurrency(totalAjustado)}</strong>.
          La columna "Original" muestra el valor crudo del POS (puede tener bug de duplicación).
        </div>
      )}

      {/* Tabla */}
      <div style={{ border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden", background: "#fff" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ background: "#f1f5f9" }}>
              <th style={{ padding: "10px 12px", textAlign: "left", fontSize: 11, color: "#475569", textTransform: "uppercase", fontWeight: 600 }}>Método</th>
              <th style={{ padding: "10px 12px", textAlign: "right", fontSize: 11, color: "#475569", textTransform: "uppercase", fontWeight: 600 }}>Valor original</th>
              <th style={{ padding: "10px 12px", textAlign: "right", fontSize: 11, color: "#475569", textTransform: "uppercase", fontWeight: 600 }}>Valor ajustado</th>
              <th style={{ padding: "10px 12px", textAlign: "right", fontSize: 11, color: "#475569", textTransform: "uppercase", fontWeight: 600 }}>Δ</th>
              <th style={{ padding: "10px 12px", textAlign: "center", fontSize: 11, color: "#475569", textTransform: "uppercase", fontWeight: 600 }}>Regla</th>
            </tr>
          </thead>
          <tbody>
            {metodos.map((m, i) => {
              const orig = Number(m.valor_original) || 0
              const ajus = Number(m.valor_ajustado) || 0
              const dif = ajus - orig
              const ajustado = Math.abs(dif) > 0.01
              return (
                <tr key={i} style={{ borderBottom: "1px solid #f1f5f9" }}>
                  <td style={{ padding: "10px 12px", color: "#0f172a", fontWeight: 500 }}>
                    <span style={{ display: "inline-block", width: 10, height: 10, borderRadius: "50%", background: colorPara(i), marginRight: 8 }} />
                    {m.tipo || "—"}
                  </td>
                  <td style={{
                    padding: "10px 12px", textAlign: "right",
                    color: ajustado ? "#94a3b8" : "#475569",
                    textDecoration: ajustado ? "line-through" : "none",
                    fontWeight: 500,
                  }}>
                    {formatCurrency(orig)}
                  </td>
                  <td style={{ padding: "10px 12px", textAlign: "right", color: "#0f172a", fontWeight: 700 }}>
                    {formatCurrency(ajus)}
                  </td>
                  <td style={{
                    padding: "10px 12px", textAlign: "right", fontWeight: 600,
                    color: dif > 0 ? "#10b981" : dif < 0 ? "#ef4444" : "#94a3b8",
                  }}>
                    {dif !== 0 ? `${dif > 0 ? "+" : ""}${formatCurrency(dif)}` : "—"}
                  </td>
                  <td style={{ padding: "10px 12px", textAlign: "center" }}>
                    <ReglaBadge regla={m.regla_aplicada} />
                  </td>
                </tr>
              )
            })}
          </tbody>
          <tfoot>
            <tr style={{ background: "#f8fafc", borderTop: "2px solid #e2e8f0" }}>
              <td style={{ padding: "10px 12px", fontWeight: 700, color: "#0f172a" }}>Totales</td>
              <td style={{ padding: "10px 12px", textAlign: "right", color: "#94a3b8", fontWeight: 700 }}>
                {formatCurrency(totalOriginal)}
              </td>
              <td style={{ padding: "10px 12px", textAlign: "right", color: "#0f172a", fontWeight: 700, fontSize: 14 }}>
                {formatCurrency(totalAjustado)}
              </td>
              <td colSpan={2} />
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  )
}

PagosTab.propTypes = { data: PropTypes.object }

export default PagosTab
